module.exports = __webpack_public_path__ + "static/media/logo.11e1a5d0.svg";